const countryCodes = [
    { code: "+1", label: "🇺🇸" }, // United States
    { code: "+44", label: "🇬🇧" }, // United Kingdom
    { code: "+91", label: "🇮🇳" }, // India
    { code: "+61", label: "🇦🇺" }, // Australia
    { code: "+33", label: "🇫🇷" }, // France
    { code: "+49", label: "🇩🇪" }, // Germany
    { code: "+81", label: "🇯🇵" }, // Japan
    { code: "+86", label: "🇨🇳" }, // China
    { code: "+39", label: "🇮🇹" }, // Italy
    { code: "+7", label: "🇷🇺" }, // Russia
    { code: "+55", label: "🇧🇷" }, // Brazil
    { code: "+34", label: "🇪🇸" }, // Spain
    { code: "+62", label: "🇮🇩" }, // Indonesia
    { code: "+52", label: "🇲🇽" }, // Mexico
    { code: "+27", label: "🇿🇦" }, // South Africa
    { code: "+82", label: "🇰🇷" }, // South Korea
    { code: "+90", label: "🇹🇷" }, // Turkey
    { code: "+971", label: "🇦🇪" }, // UAE
    { code: "+972", label: "🇮🇱" }, // Israel
    { code: "+965", label: "🇰🇼" }, // Kuwait
    { code: "+966", label: "🇸🇦" }, // Saudi Arabia
    { code: "+31", label: "🇳🇱" }, // Netherlands
    { code: "+41", label: "🇨🇭" }, // Switzerland
    { code: "+46", label: "🇸🇪" }, // Sweden
    { code: "+47", label: "🇳🇴" }, // Norway
    { code: "+48", label: "🇵🇱" }, // Poland
    { code: "+420", label: "🇨🇿" }, // Czech Republic
    { code: "+43", label: "🇦🇹" }, // Austria
    { code: "+32", label: "🇧🇪" }, // Belgium
    { code: "+351", label: "🇵🇹" }, // Portugal
    { code: "+353", label: "🇮🇪" }, // Ireland
    { code: "+358", label: "🇫🇮" }, // Finland
    { code: "+357", label: "🇨🇾" }, // Cyprus
    { code: "+370", label: "🇱🇹" }, // Lithuania
    { code: "+371", label: "🇱🇻" }, // Latvia
    { code: "+372", label: "🇪🇪" }, // Estonia
    { code: "+380", label: "🇺🇦" }, // Ukraine
    { code: "+375", label: "🇧🇾" }, // Belarus
    { code: "+56", label: "🇨🇱" }, // Chile
    { code: "+57", label: "🇨🇴" }, // Colombia
    { code: "+58", label: "🇻🇪" }, // Venezuela
    { code: "+63", label: "🇵🇭" }, // Philippines
    { code: "+64", label: "🇳🇿" }, // New Zealand
    { code: "+66", label: "🇹🇭" }, // Thailand
    { code: "+84", label: "🇻🇳" }, // Vietnam
    { code: "+92", label: "🇵🇰" }, // Pakistan
    { code: "+94", label: "🇱🇰" }, // Sri Lanka
    { code: "+95", label: "🇲🇲" }, // Myanmar
    { code: "+98", label: "🇮🇷" }, // Iran
    { code: "+212", label: "🇲🇦" }, // Morocco
    { code: "+213", label: "🇩🇿" }, // Algeria
    { code: "+216", label: "🇹🇳" }, // Tunisia
    { code: "+218", label: "🇱🇾" }, // Libya
    { code: "+220", label: "🇬🇲" }, // Gambia
    { code: "+221", label: "🇸🇳" }, // Senegal
    { code: "+222", label: "🇲🇷" }, // Mauritania
    { code: "+223", label: "🇲🇱" }, // Mali
    { code: "+225", label: "🇨🇮" }, // Côte d'Ivoire
    { code: "+230", label: "🇲🇺" }, // Mauritius
    { code: "+234", label: "🇳🇬" }, // Nigeria
    { code: "+237", label: "🇨🇲" }, // Cameroon
    { code: "+250", label: "🇷🇼" }, // Rwanda
    { code: "+254", label: "🇰🇪" }, // Kenya
    { code: "+255", label: "🇹🇿" }, // Tanzania
    { code: "+256", label: "🇺🇬" }, // Uganda
    { code: "+260", label: "🇿🇲" }, // Zambia
    { code: "+263", label: "🇿🇼" }, // Zimbabwe
    { code: "+591", label: "🇧🇴" }, // Bolivia
    { code: "+598", label: "🇺🇾" }, // Uruguay
    { code: "+880", label: "🇧🇩" }, // Bangladesh
    { code: "+960", label: "🇲🇻" }, // Maldives
    { code: "+975", label: "🇧🇹" }, // Bhutan
    { code: "+998", label: "🇺🇿" }, // Uzbekistan
  ];
  
  export default countryCodes;
  